(function () {
  function initJotformContactForm(root) {
    var nameInput = root.querySelector('[data-contact-name-input]');
    var firstHidden = root.querySelector('[data-contact-name-first]');
    var lastHidden = root.querySelector('[data-contact-name-last]');
    var messageInput = root.querySelector('[data-contact-message-input]');
    var successMessage = root.querySelector('[data-contact-form-success]');
    var errorMessage = root.querySelector('[data-contact-form-error]');
    var submitDateInput = root.querySelector('[data-contact-submit-date]');
    var spcInput = root.querySelector('[data-contact-jotform-spc]');
    var formId = root.getAttribute('data-contact-jotform-id');
    var submitButton = root.querySelector('.rabitat-contact__submit');
    var defaultSubmitLabel = submitButton
      ? submitButton.getAttribute('data-contact-submit-default') || submitButton.textContent.trim()
      : 'Submit enquiry';
    var loadingSubmitLabel = submitButton
      ? submitButton.getAttribute('data-contact-submit-loading') || 'Submitting...'
      : 'Submitting...';
    var iframeName = 'contact-jotform-target-' + (formId || 'form');
    var iframe = document.createElement('iframe');
    var awaitingResponse = false;
    var responseTimeoutId = 0;

    iframe.name = iframeName;
    iframe.title = 'Form submission';
    iframe.hidden = true;
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
    root.appendChild(iframe);

    function setSubmitting(isSubmitting) {
      if (!submitButton) return;
      submitButton.disabled = isSubmitting;
      submitButton.textContent = isSubmitting ? loadingSubmitLabel : defaultSubmitLabel;
      if (isSubmitting) {
        submitButton.setAttribute('aria-busy', 'true');
      } else {
        submitButton.removeAttribute('aria-busy');
      }
    }

    function hideStatusMessages() {
      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;
    }

    function resetSelects() {
      root.querySelectorAll('.rabitat-contact__select').forEach(function (select) {
        select.selectedIndex = 0;
      });
    }

    function showSuccess() {
      setSubmitting(false);
      root.reset();
      resetSelects();
      if (messageInput) messageInput.value = '';
      hideStatusMessages();
      if (successMessage) {
        successMessage.hidden = false;
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function showError() {
      setSubmitting(false);
      hideStatusMessages();
      if (errorMessage) {
        errorMessage.hidden = false;
        errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function prepareSubmissionFields() {
      if (nameInput && firstHidden && lastHidden) {
        var parts = nameInput.value.trim().split(/\s+/).filter(Boolean);
        firstHidden.value = parts[0] || '';
        lastHidden.value = parts.slice(1).join(' ') || parts[0] || '';
      }

      if (submitDateInput) {
        submitDateInput.value = new Date().toISOString();
      }

      if (spcInput && formId) {
        spcInput.value = formId + '-' + formId;
      }
    }

    iframe.addEventListener('load', function () {
      if (!awaitingResponse) return;

      awaitingResponse = false;
      window.clearTimeout(responseTimeoutId);

      var submissionFailed = false;

      try {
        var doc = iframe.contentDocument || iframe.contentWindow.document;
        var bodyText = doc && doc.body ? doc.body.textContent : '';
        submissionFailed = /request failed|please try again/i.test(bodyText || '');
      } catch (error) {
        submissionFailed = false;
      }

      if (submissionFailed) {
        showError();
        return;
      }

      showSuccess();
    });

    root.addEventListener('submit', function (event) {
      event.preventDefault();
      hideStatusMessages();
      prepareSubmissionFields();
      setSubmitting(true);
      awaitingResponse = true;
      window.clearTimeout(responseTimeoutId);
      responseTimeoutId = window.setTimeout(function () {
        if (!awaitingResponse) return;
        awaitingResponse = false;
        showError();
      }, 30000);

      root.target = iframeName;
      root.submit();
    });
  }

  document.querySelectorAll('[data-contact-jotform]').forEach(initJotformContactForm);
})();
